
import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedSDKImportCompleteStepWithI18n } from './delayed-sdk-import-complete-step';

export const SDKImportCompleteStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.IMPORT_COMPLETE,
  render: () => <DelayedSDKImportCompleteStepWithI18n />,
};
